import { render, staticRenderFns } from "./DynamicLayout.vue?vue&type=template&id=47a98eaa"
import script from "./DynamicLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicLayout.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DynamicLayout.vue?vue&type=style&index=0&id=47a98eaa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports